/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Storage } from './storage';
import { StorageDirectory } from './storageDirectory';
import { StorageFile } from './storageFile';
import { StorageUnitStatusChangeEvent } from './storageUnitStatusChangeEvent';


export interface StorageUnit { 
    storage: Storage;
    storageDirectory?: StorageDirectory;
    /**
     * A container of various Storage Files that reside within a specific Storage Unit
     */
    storageFiles?: Array<StorageFile>;
    /**
     * The status of this Storage Unit. One of the following values: ENABLED, DISABLED, ARCHIVING, or RESTORING
     */
    storageUnitStatus?: string;
    /**
     * Lists all storage unit status change events for this storage unit
     */
    storageUnitStatusHistory?: Array<StorageUnitStatusChangeEvent>;
    /**
     * The number of failed attempts to execute a storage policy transition such as archiving to Glacier
     */
    storagePolicyTransitionFailedAttempts?: number;
    /**
     * The restore expiration time if restored
     */
    restoreExpirationOn?: Date;
}
